import queryString from "query-string";
import store from "rootStore";

const generateBookingLink = (link: string, params?: Record<string, any>) => {
    const geh = sessionStorage.getItem("geh");
    const groupId = store.getState().app?.settings?.data?.uid;
    const lang = document.documentElement.lang;

    return `${link}?${queryString.stringify({ geh, portal_group: groupId, locale: lang, ...params })}`;
};

export default generateBookingLink;
